import {BaseComponent} from '../../abstract/base.component';
import {ApiErrorModel} from '../../data/model/ApiErrorModel/api-error.model';
import {Directive} from '@angular/core';

@Directive()
export abstract class SetupTotpAction extends BaseComponent {
  protected getOtpUrl: string;
  protected verifyOtpUrl: string;
  protected completeOtpUrl: string;

  protected abstract passSendOtpEmailResponse(res);

  protected abstract passSendOtpEmailError(error: ApiErrorModel);

  protected abstract passVerifyAppOtpResponse(res);

  protected abstract passVerifyAppOtpError(error: ApiErrorModel);

  protected abstract passCompleteAppOtpResponse(res);

  protected abstract passCompleteAppOtpError(error: ApiErrorModel);

  sendOtpEmail(postBody) {
    this.loadFlag2 = true;
    this.dataManager.postRequest(this.getOtpUrl, postBody)
      .subscribe(
        res => this.passSendOtpEmailResponse(res),
        error => {
          this.loadFlag2 = false;
          this.networkErrorHandler(error.error);
          this.passSendOtpEmailError(error.error);
        }
      );
  }

  verifyOtp(postbody) {
    this.loadFlag = true;
    this.dataManager.postRequest(this.verifyOtpUrl, postbody)
      .subscribe(
        res => this.passVerifyAppOtpResponse(res),
        error => {
          this.loadFlag = false;
          this.networkErrorHandler(error.error);
          this.passVerifyAppOtpError(error.error);
        }
      );
  }

  completeOtp(postbody) {
    this.loadFlag = true;
    this.dataManager.postRequest(this.completeOtpUrl, postbody)
      .subscribe(
        res => this.passCompleteAppOtpResponse(res),
        error => {
          this.loadFlag = false;
          this.networkErrorHandler(error.error);
          this.passCompleteAppOtpError(error.error);
        }
      );
  }
}
